import { Grid, styled, Typography } from '@mui/material';
import { UserDTO } from '@oh-vcp/components-common';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const SpecialistContainer = styled(Grid)(({ theme }) => ({
  borderColor: theme.palette.base.grey5,
  borderStyle: 'solid',
  borderWidth: 1,
  padding: 5,
  paddingLeft: 10,
  width: '75%'
}));

interface EconsultSpecialistDetailsProps {
  specialist: UserDTO;
}

const EconsultSpecialistDetails: FC<EconsultSpecialistDetailsProps> = ({ specialist }) => {
  const { t } = useTranslation();
  const { specialty, organization, address, city } = specialist;

  return (
    <SpecialistContainer container rowGap={1} mt={0.5}>
      <Grid item xs={12} md={4} xl={2}>
        <Typography variant="body2" color="base.grey4">
          {t('Case.specialist.specialties')}:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} xl={10}>
        <Typography variant="body2" color="base.grey3">
          {specialty}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} xl={2}>
        <Typography variant="body2" color="base.grey4">
          {t('Case.specialist.organization')}:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} xl={10}>
        <Typography variant="body2" color="base.grey3">
          {organization}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} xl={2}>
        <Typography variant="body2" color="base.grey4">
          {t('Case.specialist.address')}:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} xl={10}>
        <Typography variant="body2" color="base.grey3">
          {address}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} xl={2}>
        <Typography variant="body2" color="base.grey4">
          {t('Case.specialist.city')}:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8} xl={10}>
        <Typography variant="body2" color="base.grey3">
          {city}
        </Typography>
      </Grid>
    </SpecialistContainer>
  );
};

export default EconsultSpecialistDetails;
